import { FC } from 'react'
import { Rectangle } from 'react-leaflet'

import { ShapeType } from '@kouto/types'
import { useDraggableShape } from 'hooks'
import { MapShapeProps } from './Shape'

export const DraggableRectangle: FC<MapShapeProps> = ({
  canDragOutsideMap,
  mapSize,
  ...shape
}) => {
  const { bounds, shapeRef } = useDraggableShape<ShapeType.RECTANGLE>(
    shape,
    canDragOutsideMap,
    mapSize,
  )

  return (
    <Rectangle
      key={`${shape.id}-${shape.color}`}
      ref={shapeRef}
      bounds={bounds}
      color="#FFFFFF"
      opacity={1}
      fillOpacity={1}
      fillColor={shape.color}
      className={shape.className}
    >
      {shape.children}
    </Rectangle>
  )
}
